import React, { useState, useEffect } from "react";
import { Modal, Input, Switch, Select } from "antd";
import floppyDiskImg from "../../../../assets/img/floppy-disk.svg";
import Title from "./components/title.js";
import { Link, useNavigate } from "react-router-dom";
import {
  TackleRadioButtons,
  SackRadioButtons,
  FlagSwitchButtons,
} from "../CustomSwitchButtons.js";
import positiveImpact from "../../../../assets/img/positiveImpact.svg";
import positiveImpactAction from "../../../../assets/img/Action.svg";

function DefensiveModal({
  state,
  dispatch,
  close,
  update,
  getStats,
  school_id,
  schoolCustomStats,
  item,
  updateGrade,
  updateInputGrade,
  handleExpandToggle,
  handleQuickUpdate,
}) {
  let history = useNavigate();
  const [modalWidth, setModalWidth] = useState(425);
  const [customStats, setCustomStats] = useState([]);
  const [customStatValues, setCustomStatValues] = useState({});
  const [storage, setStorage] = useState({});

  useEffect(() => {
    setStorage(item);
  }, [item]);
  const updateStorage = (path, value) => {
    const store = storage;
    store[path] = value;

    setStorage(store);
    updateGrade(path, value);
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setModalWidth(352);
    } else {
      setModalWidth(425);
    }
  }, [window.innerWidth]);

  const handleCStats = () => {
    setCustomStatValues(JSON.parse(item?.custom_stats || "{}"));
    const _customStats = schoolCustomStats?.filter((stat) => stat.odk == "d");
    setCustomStats(_customStats || []);
  };
  useEffect(handleCStats, [item?.custom_stats, schoolCustomStats]);
  useEffect(handleCStats, []);

  const handleSaveCustomStat = (stat, value) => {
    const _customStatValues = { ...customStatValues };
    _customStatValues[stat.label] = value;
    setCustomStatValues(_customStatValues);
    updateGrade("custom_stats", JSON.stringify(_customStatValues));
  };

  return (
    state.defensive && (
      <div className="w-full text-[12px] flex justify-between text-[#0F1A24]">
        <div style={{ border: "1px solid #F3F5F7" }} className="w-[49%]">
          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Tackle</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <TackleRadioButtons
                item={item}
                defaultState={item?.tackles}
                handleQuickUpdate={handleQuickUpdate}
                title="tackles"
                tooltipTitle="Missed Tackle"
                textTwo="AST"
                tooltipTitleTwo="Assisted Tackle"
                textThree={1}
              />
            </div>
          </div>

          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Behind Line of Scrimmage</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <SackRadioButtons
                item={item}
                defaultState={item?.sacks}
                handleQuickUpdate={handleQuickUpdate}
                title="sacks"
                tooltipTitle="Tackle for a Loss"
                tooltipTitleTwo="Pressure"
              />
            </div>
          </div>
          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Caused Fumble</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={item?.caused_fumble}
                onChange={(e) => updateGrade("caused_fumble", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Fumble Recovered</span>
            </div>{" "}
            <div className="p-2 w-[30%] flex items-center justify-center">
              <div className="w-[100%] p-1 turn-over actor flex items-center justify-center rounded-[4px]">
                <Switch
                  defaultChecked={item?.recovered_fumble}
                  onChange={(e) => updateStorage("recovered_fumble", e ? 1 : 0)}
                />
              </div>
            </div>
          </div>

          {storage.recovered_fumble ? (
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid #F3F5F7" }}
            >
              <div
                className="w-[70%] px-2 py-2 font-bold"
                style={{ borderRight: "1px solid #F3F5F7" }}
              >
                <span>Yards After Recovery</span>
              </div>{" "}
              <div className="p-2 px-0 w-[30%] turn-over actor flex items-center justify-center">
                <Input
                  defaultValue={item?.yards_after_recovery}
                  onChange={(e) => updateInputGrade("yards_after_recovery", e)}
                  size="small"
                  className="w-[40%] p-1"
                />{" "}
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Interception</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={item?.interception}
                onChange={(e) => updateStorage("interception", e ? 1 : 0)}
              />{" "}
            </div>
          </div>

          {storage.interception ? (
            <div
              className="flex items-center"
              style={{ borderBottom: "1px solid #F3F5F7" }}
            >
              <div
                className="w-[70%] px-2 py-2 font-bold"
                style={{ borderRight: "1px solid #F3F5F7" }}
              >
                <span>Yards After Interception</span>
              </div>{" "}
              <div className="p-2 px-0 w-[30%] turn-over actor flex items-center justify-center">
                <Input
                  defaultValue={item?.yards_after_interception}
                  onChange={(e) =>
                    updateInputGrade("yards_after_interception", e)
                  }
                  size="small"
                  className="w-[40%] p-1"
                />{" "}
              </div>
            </div>
          ) : (
            ""
          )}

          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>PBU - Pass Breakup</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={item?.pbu_pass_breakup}
                onChange={(e) => updateGrade("pbu_pass_breakup", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Safety</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={item?.safety}
                onChange={(e) => updateGrade("safety", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Big Hit</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={item?.big_hit}
                onChange={(e) => updateGrade("big_hit", e ? 1 : 0)}
              />{" "}
            </div>
          </div>

          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>TD</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={item?.td}
                onChange={(e) => updateGrade("td", e ? 1 : 0)}
              />{" "}
            </div>
          </div>

          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Flag</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <FlagSwitchButtons
                item={item}
                defaultState={item?.penalties}
                handleQuickUpdate={handleQuickUpdate}
                title="penalties"
              />
            </div>
          </div>

          <div
            className="flex items-center"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[70%] px-2 py-2 font-bold"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Positive Impact</span>
            </div>{" "}
            <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
              <div
                onClick={() => {
                  if (item?.disabled) return;
                  handleQuickUpdate(
                    item?.id,
                    item?.athlete,
                    "positive_impact",
                    !item?.positive_impact ? 1 : 0
                  );
                }}
                className="flex w-[100%] items-center justify-center"
              >
                {item?.positive_impact == 1 && (
                  <img
                    src={positiveImpactAction}
                    className="w-[60%] max-w-[38px] cursor-pointer"
                  />
                )}
                {(item?.positive_impact === 0 || !item?.positive_impact) && (
                  <img
                    src={positiveImpact}
                    className="w-[60%] max-w-[38px] cursor-pointer"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="w-[49%]">
          <div className="flex items-center text-md mb-2">
            <button
              onClick={() => handleExpandToggle(item, "defensive-modal")}
              className="flex items-center focus:outline-0 justify-center w-fit bg-[#1A91FF] text-[#ffffff] px-3 py-2 rounded-[4px]"
            >
              <img src={floppyDiskImg} className="w-6" />
              <span className="ml-2">Save and close</span>
            </button>
          </div>
          {customStats.length > 0 && (
            <>
              <span className="font-inter text-[14px] font-bold">
                Custom Defensive Stats{" "}
              </span>
              <div
                style={{ border: "1px solid #F3F5F7" }}
                className="mt-1 text-[12px] text-[#0F1A24] mb-2"
              >
                {customStats?.map((stat) => (
                  <div
                    key={stat.label}
                    className="flex items-center"
                    style={{ borderBottom: "1px solid #F3F5F7" }}
                  >
                    <div
                      className="w-[70%] px-2 py-2 font-bold"
                      style={{ borderRight: "1px solid #F3F5F7" }}
                    >
                      <span>{stat.label}</span>
                    </div>{" "}
                    <div className="px-2 py-2 w-[30%] turn-over actor flex items-center justify-center">
                      {stat.input_type == "numeric" ? (
                        <Input
                          defaultValue={
                            JSON.parse(item?.custom_stats || "{}")[stat.label]
                          }
                          onChange={(e) =>
                            handleSaveCustomStat(stat, e.target.value)
                          }
                          size="small"
                          className="w-[40%] p-1"
                        />
                      ) : (
                        <Switch
                          defaultChecked={
                            JSON.parse(item?.custom_stats || "{}")[stat.label]
                          }
                          onChange={(e) =>
                            handleSaveCustomStat(stat, e ? 1 : 0)
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
          <span className="text-[#8698A9]">
            Edit custom stats in your{" "}
            <span
              onClick={() => history("/add-stats")}
              className="underline cursor-pointer"
            >
              Admin Settings
            </span>
          </span>
        </div>
      </div>
    )
  );
}

export default DefensiveModal;
